module.exports = __webpack_public_path__ + "a15d3749cc1486c5efea096a23c1372c.jpg";